import React, { useEffect, useState } from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import "./ContexteFiscal.css";

const RevenusPro = (props) => {
  const { Outil } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const Periode = context.state[Outil + "PeriodeActuelle"] === undefined ? undefined : context.state[Outil + "PeriodeActuelle"][0];
  const PeriodeConjoint = context.state[Outil + "PeriodeActuelleConjoint"] === undefined ? undefined : context.state[Outil + "PeriodeActuelleConjoint"][0];

  const [remunerationDeclaree, setRemunerationDeclaree] = useState(0);
  const [remunerationDeclareeConjoint, setRemunerationDeclareeConjoint] = useState(0);
  useEffect(() => {
    // if (props.visible === true) {
    if (Periode !== undefined && context.state.TypeSimulation !== "Audit rémunération") {
      if (Outil === "") {
        if (Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel") {
          ResultatTNS.GetResultRemExpert(context.state, "").then(() => {
            if (Periode?.Statut === "TNS individuel" && Periode?.ModeExercice === "IS") {
              setRemunerationDeclaree((ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable * Periode?.PartRemunerationMandat) / 100);
            } else if (Periode?.Statut === "TNS individuel" && Periode?.ModeExercice === "IR") {
              setRemunerationDeclaree(0);
            } else {
              setRemunerationDeclaree(ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable);
            }
          });
        } else {
          ResultatSalarie.GetResultRemExpert(context.state, "").then(() => {
            setRemunerationDeclaree(ResultatSalarie.state[Outil + "RemunerationSalarie"]?.BrutImposable);
          });
        }

        if (context.state.InclureConjoint === true && Periode?.StatutConjoint !== "Aucun") {
          if (Periode?.StatutConjoint === "TNS Article 62" || Periode?.StatutConjoint === "TNS individuel") {
            ResultatTNS.GetResultRemExpert(context.state, "ConjointAssocie").then(() => {
               if (Periode?.StatutConjoint === "TNS individuel" && Periode?.ModeExercice === "IS") {
                setRemunerationDeclareeConjoint((ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable * Periode?.PartRemunerationMandatConjoint) / 100);
              } else if (Periode?.StatutConjoint === "TNS individuel" && Periode?.ModeExercice === "IR") {
                setRemunerationDeclareeConjoint(0);
              } else {
                setRemunerationDeclareeConjoint(ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable);
              }
            });
          } else {
            ResultatSalarie.GetResultRemExpert(context.state, "ConjointAssocie").then(() => {
              setRemunerationDeclareeConjoint(ResultatSalarie.state[Outil + "RemunerationSalarieConjoint"]?.BrutImposable);
            });
          }
        }
      } else if (Outil === "OptiRem") {
        if (Periode?.Statut === "TNS individuel" && Periode?.ModeExercice === "IS") {
          setRemunerationDeclaree((ResultatTNS.state.OptiRemRemuneration?.BrutImposable * Periode?.PartRemunerationMandat) / 100);
        } else {
          setRemunerationDeclaree(ResultatTNS.state.OptiRemRemuneration?.BrutImposable);
        }
        if (context.state.InclureConjoint === true && Periode?.StatutConjoint !== "Aucun") {
          if (Periode?.StatutConjoint === "TNS individuel" && Periode?.ModeExercice === "IS") {
            setRemunerationDeclareeConjoint((ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable * Periode?.PartRemunerationMandatConjoint) / 100);
          } else {
            setRemunerationDeclareeConjoint(ResultatTNS.state.OptiRemRemunerationConjoint?.BrutImposable);
          }
        }
      }
    }
    if (PeriodeConjoint !== undefined) {
      if (PeriodeConjoint?.Statut === "TNS Article 62" || PeriodeConjoint?.Statut === "TNS individuel") {
        ResultatTNS.GetResultRemExpert(context.state, "Conjoint").then(() => {
               if (PeriodeConjoint?.Statut === "TNS individuel" && PeriodeConjoint?.ModeExercice === "IS") {
            setRemunerationDeclareeConjoint((ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable * PeriodeConjoint?.PartRemunerationMandat) / 100);
          } else if (PeriodeConjoint?.Statut === "TNS individuel" && PeriodeConjoint?.ModeExercice === "IR") {
            setRemunerationDeclareeConjoint(0);
          } else {
            setRemunerationDeclareeConjoint(ResultatTNS.state[Outil + "RemunerationTNSConjoint"]?.BrutImposable);
          }
        });
      } else {
        ResultatSalarie.GetResultRemExpert(context.state, "Conjoint").then(() => {
          setRemunerationDeclareeConjoint(ResultatSalarie.state[Outil + "RemunerationSalarieConjoint"]?.BrutImposable);
        });
      }
    }
    if (context.state.TypeSimulation === "Audit rémunération") {
      if (Periode?.Statut === "TNS Article 62") {
        if (Outil === "") {
          setRemunerationDeclaree(ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable);
        } else if (Outil === "OptiRem") {
          setRemunerationDeclaree(ResultatTNS.state.OptiRemRemuneration?.BrutImposable);
        } else {
          setRemunerationDeclaree(ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable);
        }
      } else if (Periode?.Statut === "TNS individuel") {
        if (Outil === "") {
          if (context.state.ModeExercice === "IS") {
            setRemunerationDeclaree((ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable * context.state.PartRemunerationMandat) / 100);
          } else {
            setRemunerationDeclaree(0);
          }
        } else if (Outil === "OptiRem") {
          console.log(context.state.OptiRemModeExercice);
          if (context.state.OptiRemModeExercice === "IS") {
            setRemunerationDeclaree((ResultatTNS.state.OptiRemRemuneration?.BrutImposable * context.state.OptiRemPartRemunerationMandat) / 100);
          } else {
            setRemunerationDeclaree(0);
          }
        } else {
          setRemunerationDeclaree(0);
        }
      } else {
        if (Outil === "") {
          setRemunerationDeclaree(ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable);
        } else if (Outil === "OptiRem") {
          setRemunerationDeclaree(ResultatTNS.state.OptiRemRemuneration?.BrutImposable);
        } else {
          setRemunerationDeclaree(ResultatSalarie.state[Outil + "RemunerationSalarie"]?.BrutImposable);
        }
      }
    }
    //   Periode?.Statut === "TNS Article 62"
    //     ? context.state.TypeSimulation === "Audit rémunération" && Outil === ""
    //       ? ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable
    //       : Outil === "OptiRem"
    //       ? ResultatTNS.state.OptiRemRemuneration?.BrutImposable
    //       : ResultatTNS.state[Outil + "RemunerationTNS"]?.BrutImposable
    //     : Periode?.Statut === "TNS individuel"
    //     ? 0
    //     : context.state.TypeSimulation === "Audit rémunération" && Outil === ""
    //     ? ResultatTNS.state["RemExpressRemuneration"]?.BrutImposable
    //     : Outil === "OptiRem"
    //     ? ResultatTNS.state.OptiRemRemuneration?.BrutImposable
    //     : ResultatSalarie.state[Outil + "RemunerationSalarie"]?.BrutImposable
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);
  // RemExpressRemuneration
  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">💼</span>
          Catégorie
        </div>
        <div className="value-column">
          <span className="header-icon">👤</span>
          Client
        </div>
        <div className="value-column">
          <span className="header-icon">👥</span>
          Conjoint
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">

        {/* Rémunération déclarée */}
        {Periode !== undefined && (
          <div className="card">
            <div className="category-column">
              <div className="titre-icone">€</div>
              Rémunération déclarée sur l'activité étudiée
            </div>
            <div className="value-column">
              <TextField
                value={remunerationDeclaree}
                dataType="uint"
                format={{ thousands: " ", unit: " €" }}
                normal
                disabled={true}
              />
            </div>
            <div className="value-column">
              {context.state.TypeSimulation !== "Audit rémunération" && (
                <TextField
                  value={remunerationDeclareeConjoint}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  normal
                  disabled={true}
                />
              )}
            </div>
          </div>
        )}

        {/* Traitements et salaires */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">💰</div>
            Traitements et salaires provenant d'autres activités
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantTraitement"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantTraitement")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointTraitement"]}
              onChange={context.handleInputChange(Outil + "IRConjointTraitement")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Autres revenus imposables */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            Autres revenus imposables (allocations chômage…)
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAutresRevenus"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAutresRevenus")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRConjointAutresRevenus"]}
              onChange={context.handleInputChange(Outil + "IRConjointAutresRevenus")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Abattement appliqué */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">⚖️</div>
            Abattement appliqué
          </div>
          <div className="value-column">
            <DropDown
              value={context.state[Outil + "IRDirigeantAbattement"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAbattement")}
              options={[
                { value: "Forfaitaire", label: "Forfaitaire" },
                { value: "Reel", label: "Au réel" },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state[Outil + "IRConjointAbattement"]}
              onChange={context.handleInputChange(Outil + "IRConjointAbattement")}
              options={[
                { value: "Forfaitaire", label: "Forfaitaire" },
                { value: "Reel", label: "Au réel" },
              ]}
              normal
            />
          </div>
        </div>

        {/* Frais réels */}
        {(context.state[Outil + "IRDirigeantAbattement"] === "Reel" || context.state[Outil + "IRConjointAbattement"] === "Reel") && (
          <div className="card">
            <div className="category-column">
              <div className="titre-icone">🧾</div>
              Frais réels
            </div>
            <div className="value-column">
              {context.state[Outil + "IRDirigeantAbattement"] === "Reel" ? (
                <TextField
                  value={context.state[Outil + "IRDirigeantFraisReel"]}
                  onChange={context.handleInputChange(Outil + "IRDirigeantFraisReel")}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  normal
                />
              ) : (
                <span style={{ fontSize: '12px', color: '#9ca3af' }}>Non applicable</span>
              )}
            </div>
            <div className="value-column">
              {context.state[Outil + "IRConjointAbattement"] === "Reel" ? (
                <TextField
                  value={context.state[Outil + "IRConjointFraisReel"]}
                  onChange={context.handleInputChange(Outil + "IRConjointFraisReel")}
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                  normal
                />
              ) : (
                <span style={{ fontSize: '12px', color: '#9ca3af' }}>Non applicable</span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenusPro;
